const DetailPanel = () => {
  return <p>customer detail panel </p>
}

export default DetailPanel
